export default __webpack_public_path__ + "static/stress-1b322f08bed3ee6a741e75d56d1c0c5f.png";